import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Replace
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgNGMwLTEuMS45LTIgMi0yIiAvPgogIDxwYXRoIGQ9Ik0yMCAyYzEuMSAwIDIgLjkgMiAyIiAvPgogIDxwYXRoIGQ9Ik0yMiA4YzAgMS4xLS45IDItMiAyIiAvPgogIDxwYXRoIGQ9Ik0xNiAxMGMtMS4xIDAtMi0uOS0yLTIiIC8+CiAgPHBhdGggZD0ibTMgNyAzIDMgMy0zIiAvPgogIDxwYXRoIGQ9Ik02IDEwVjVjMC0xLjcgMS4zLTMgMy0zaDEiIC8+CiAgPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iOCIgeD0iMiIgeT0iMTQiIHJ4PSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/replace
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Replace = createLucideIcon('Replace', [
  ['path', { d: 'M14 4c0-1.1.9-2 2-2', key: '1mvvbw' }],
  ['path', { d: 'M20 2c1.1 0 2 .9 2 2', key: '1mj6oe' }],
  ['path', { d: 'M22 8c0 1.1-.9 2-2 2', key: 'v1wql3' }],
  ['path', { d: 'M16 10c-1.1 0-2-.9-2-2', key: '821ux0' }],
  ['path', { d: 'm3 7 3 3 3-3', key: 'x25e72' }],
  ['path', { d: 'M6 10V5c0-1.7 1.3-3 3-3h1', key: '13af7h' }],
  [
    'rect',
    { width: '8', height: '8', x: '2', y: '14', rx: '2', key: '17ihk4' },
  ],
]);

export default Replace;
